const subscriptionTypesData = {
    free: [
        'subscription.public-projects',
        'subscription.watermark',
        'subscription.limited-export-formats'
    ],
    starter: [
        'subscription.unlimited-public-projects',
        'subscription.unlisted-projects',
        'subscription.import-stuff',
        'subscription.limited-export-formats',
        'subscription.no-end-screen',
        'subscription.basic-permissions'
    ],
    pro3: [
        'subscription.unlimited-projects',
        'subscription.no-watermark',
        'subscription.collaborative-video'
    ],
    business: [
        'subscription.unlimited-projects',
        'subscription.available-features',
        'subscription.premium-storage',
        'subscription.priority-rendering',
        'subscription.premium-support'
    ],
    wavefree: [
        'wv.subscription.5-videos',
        'wv.subscription.limited-clips',
        'wv.subscription.watermark'
    ],
    wavepro: [
        'wv.subscription.small-businesses',
        'wv.subscription.1-brand',
        'wv.subscription.3m-royalty-free',
        'wv.subscription.no-watermark',
        'wv.subscription.unlimited-videos-per-month'
    ],
    wavebusiness: [
        'wv.subscription.corporate-marketers',
        'wv.subscription.600-royalty-free',
        'wv.subscription.premium-clips',
        'wv.subscription.no-watermark',
        'wv.subscription.unlimited-videos',
        'wv.subscription.customer-support'
    ],
    waveagency: [
        'wv.subscription.corporate-marketers',
        'wv.subscription.20brands',
        'wv.subscription.white-label-preview',
        'wv.subscription.no-watermark',
        'wv.subscription.3m-stock',
        'wv.subscription.unlimited-videos',
        'wv.subscription.customer-support'
    ],
    wavebigagency: [
        'wv.subscription.Ideal-for-agencies',
        'wv.subscription.2.5-million-video',
        'wv.subscription.3rd-party-sell-them',
        'wv.subscription.videos-for-many-brands',
        'wv.subscription.Import-100Gb-media'
    ],
    waveultimate: [
        'wv.subscription.ideal-for-create-videos',
        'wv.subscription.50brands',
        'wv.subscription.3m-stock',
        'wv.subscription.white-label-preview',
        'wv.subscription.no-watermark',
        'wv.subscription.unlimited-videos',
        'wv.subscription.customer-support'
    ],
    wavesmallagency: [
        'wv.subscription.best-for-small-agencies',
        'wv.subscription.2.5-million-video',
        'wv.subscription.3rd-party-someone-else',
        'wv.subscription.videos-for-many-brands'
    ]
};
class SubscriptionTypes implements ng.IComponentController {
    subscriptionName: string;
    types: {[key: string]: string[]};

    $onChanges() {
        this.types = subscriptionTypesData[this.subscriptionName.toLowerCase()];
    }
}

angular.module('animatronApp.settings').component('subscriptionTypes', {
    bindings: {
        subscriptionName: '<'
    },
    controller: SubscriptionTypes,
    templateUrl: require('settings/subscription-types.html')
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/subscriptionTypes.ts